import React from 'react';
import { Field } from 'formik';
import CreditCardNumber from '../credit-card-number';
import CreditCardNameOn from '../credit-card-name-on';
import CreditCardExpiryDate from '../credit-card-expiry-date';
import DirectDebitServiceAgreement from '../direct-debit-service-agreement';
import { AmexIcon, MastercardIcon, VisaIcon } from '../payment-method-group/icons';
import { getGroupEventHandlerProps } from '../../util/propTypes';
import { AddFunnelPropFromContext } from '../funnel-context';
import BraintreeDropIn from '@nib/braintree-drop-in-react';
import BraintreeLoader, { BraintreeDropinContainer } from '../braintree-dropin-loader';
import styled from 'styled-components';
import { pr } from '@nib/layout';
import { ARHI_RESIDENTIAL_FUNNELS } from '../../util/constants';
import { emptyTextField } from '../base-agreement';
const IconWrapper = styled.span`
  ${pr(3)};
`;
const CreditCardSection = props => {
  const {
    braintree,
    showDirectDebitServiceAgreement,
    values,
    eventHandlers,
    funnel
  } = props;
  const isARHIFunnel = !!ARHI_RESIDENTIAL_FUNNELS[funnel || ''];
  // braintree error message render is shown above the info box section
  if (braintree) {
    // Specific to payment method group so lets not pass these down to the BT component itself
    const {
      braintreeSubmissionError = false,
      errorMessage,
      ...braintreeProps
    } = braintree;
    const hasBraintreeToken = Boolean(braintree && braintree.braintreeClientToken && braintree.braintreeClientToken.length);
    return React.createElement(React.Fragment, null, !errorMessage && React.createElement(BraintreeDropinContainer, {
      invalid: braintreeSubmissionError && hasBraintreeToken,
      loading: !hasBraintreeToken
    }, !hasBraintreeToken && React.createElement(BraintreeLoader, null), React.createElement("div", {
      className: "fs-mask"
    }, hasBraintreeToken && React.createElement(BraintreeDropIn, {
      ...braintreeProps
    }))), showDirectDebitServiceAgreement && React.createElement(DirectDebitServiceAgreement, {
      id: "creditCardAgreement",
      name: "creditCardAgreement",
      values: values,
      paymentMethod: "CreditCard",
      title: isARHIFunnel ? emptyTextField : undefined,
      description: isARHIFunnel ? emptyTextField : undefined,
      links: isARHIFunnel ? [] : undefined,
      ...getGroupEventHandlerProps({
        ...eventHandlers,
        id: 'creditCardAgreement'
      })
    }));
  } else {
    return React.createElement(React.Fragment, null, React.createElement("div", null, React.createElement(IconWrapper, null, React.createElement(VisaIcon, null)), React.createElement(IconWrapper, null, React.createElement(MastercardIcon, null)), React.createElement(IconWrapper, null, React.createElement(AmexIcon, null))), React.createElement(Field, {
      name: "creditCardNameOn",
      id: "creditCardNameOn",
      component: CreditCardNameOn,
      ...getGroupEventHandlerProps({
        ...eventHandlers,
        id: 'creditCardNameOn'
      })
    }), React.createElement(Field, {
      name: "creditCardNumber",
      id: "creditCardNumber",
      component: CreditCardNumber,
      ...getGroupEventHandlerProps({
        ...eventHandlers,
        id: 'creditCardNumber'
      })
    }), React.createElement(Field, {
      name: "creditCardExpiryDate",
      id: "creditCardExpiryDate",
      component: CreditCardExpiryDate,
      ...getGroupEventHandlerProps({
        ...eventHandlers,
        id: 'creditCardExpiryDate'
      })
    }), showDirectDebitServiceAgreement && React.createElement(DirectDebitServiceAgreement, {
      id: "creditCardAgreement",
      name: "creditCardAgreement",
      values: values,
      paymentMethod: "CreditCard",
      ...getGroupEventHandlerProps({
        ...eventHandlers,
        id: 'creditCardAgreement'
      })
    }));
  }
};
const CreditCardSectionWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(CreditCardSection, {
  ...props
}));
export default CreditCardSectionWithFunnel;